module.exports = __webpack_public_path__ + "img/player-settings.67eec77c.svg";